import moment from "moment";

export default (date: Date) => {
  return date ? moment(date).local().format("L LT") : "";
};
